export default __webpack_public_path__ + "static/media/chat-ai.406a16ab.gif";